import React, {useEffect} from 'react';
import Notifications from 'shared/components/notifications';
import Navbar from 'src/views/admin/nav-bar';
import AppLayout from 'src/components/app-layout';
import 'stylesheets/components/aptitude/typography.scss';
import 'stylesheets/raiseme-icons.scss';
import Routes from './routes';

export default function Admin() {
  useEffect(() => {
    // TODO: Remove if there is ever an admin ionic app
    // if we're in ionic mode we need to get rid of these styles
    document.body.style.position = 'static';
    document.body.style.overflow = 'auto';
    document.body.style.transform = 'none';
  }, []);

  return (
    <AppLayout topToolbars={<Navbar />}>
      <Notifications />
      <Routes />
    </AppLayout>
  );
}
